import { Fragment, useEffect } from 'react';

import { OverflowTypeSearch } from 'utils/constants/admin';

import FormSpacer from 'bloko/blocks/form/FormSpacer';
import InputText from 'bloko/blocks/inputText';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';
import Table from 'components/Table';

import fetchOverflows from 'components/Admin/Reports/OverflowReport/fetchOverflows';
import Header from 'components/Admin/Reports/OverflowReport/Header';
import Overflow from 'components/Admin/Reports/OverflowReport/Overflow';
import ReportWrapper from 'components/Admin/Reports/ReportWrapper';
import TableBody from 'components/Table/TableBody';

import { setCampaignId, setDates, setSearchType } from 'store/models/overflow';
import { useDispatch, useSelector } from 'store/utils';

const OverflowReport = () => {
    const { from, to, typeSearch, campaignId, overflows, isLoad } = useSelector((state) => state.overflow);
    const dispatch = useDispatch();
    const trl = useTrls();

    useEffect(() => {
        dispatch(fetchOverflows());
    }, [dispatch]);

    return (
        <ReportWrapper
            title={trl('admin.SectionTabs.overflow')}
            filter={
                <Fragment>
                    <Select
                        value={typeSearch}
                        onChange={({ target }) => dispatch(setSearchType(target.value))}
                        flexible
                    >
                        {Object.values(OverflowTypeSearch).map((value) => (
                            <Option key={value} value={value}>
                                {trl(`admin.OverflowReport.Filter.SearchType.${value}`)}
                            </Option>
                        ))}
                    </Select>
                    <FormSpacer>
                        {typeSearch === OverflowTypeSearch.Dates && (
                            <InputWithMultiDatePicker
                                action={(from, to) => dispatch(setDates({ from, to }))}
                                from={from}
                                to={to}
                            />
                        )}
                        {typeSearch === OverflowTypeSearch.Id && (
                            <InputText
                                value={campaignId}
                                onChange={(value) => dispatch(setCampaignId(value))}
                                size="30"
                                placeholder={trl(
                                    `admin.OverflowReport.Filter.SearchType.${OverflowTypeSearch.Id}.placeholder`
                                )}
                            />
                        )}
                    </FormSpacer>
                </Fragment>
            }
            content={
                <Table withStripes bordered>
                    <Header />
                    <TableBody>
                        {overflows.map((overflow, key) => (
                            <Overflow key={key} {...overflow} />
                        ))}
                    </TableBody>
                </Table>
            }
            isLoadContent={isLoad}
            onClickSearch={() => dispatch(fetchOverflows())}
        />
    );
};

export default OverflowReport;
